export default "__VITE_ASSET__BsN_A8gd__"